import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import MCEadTitle from "../../Title"
import NRTVerticalStack from "../../../_common/_containers/VerticalStack"
import {Validators} from "../../../_common/_form/Validators"
import NRTFormInput from "../../../_common/_form/FormInput"
import NRTFormStateManager from "../../../_common/_form/FormStateManager"
import ButtonWithChevron from "../../../_minha-central/ButtonWithChevron"
import MCEadContentCard from "../../ContentCard"
import EadRequests from "../../../../requests/ead-requests"

import moment from "moment/moment";
import MCLoadingOverlay from "../../../_minha-central/LoadingOverlay"
import _ from "lodash"


class MCEadContentForumPost extends Component {

    SIMULATE_GET_FORUM_ERROR = false


    state = {
        initialized: false,
        awaiting: false,
        form: {},
        messageSent: null,
    }


    componentDidMount() {
        this.init()
    }


    init() {

        this.setState({
            initialized: false,
            awaiting: false,
            form: {},
            messageSent: null,
        }, async () => {
            const [description, ftpCode] = this.props.message.split("||")

            await this.setState({awaiting: true})

            const req = this.SIMULATE_GET_FORUM_ERROR ?
                Promise.reject('SIMULATE_GET_FORUM_ERROR') :
                EadRequests
                    .searchForumPosts({
                        ftpCode,
                        prsCode: this.props.context.person.code
                    })

            req
                .then(resultMessage => {
                    this.setState({
                        initialized: true,
                        awaiting: false,
                        messageSent: resultMessage.forumpost[0] ? resultMessage.forumpost[0].post : undefined,
                        description,
                        ftpCode,
                        person: this.props.context.person,

                    })
                })
                .catch(error => {
                    this.setState({
                        initialized: false,
                        awaiting: false
                    })
                    this.props.onError(error, 'Ocorreu um erro ao localizar o fórum.', {method: 'componentDidMount()'})
                })
        })
    }


    componentDidUpdate(prevProps) {

        const [prevDescription, prevFtpCode] = _.get(prevProps, 'message', '||').split("||")
        const [description, ftpCode] = _.get(this.props, 'message', '||').split("||")

        if (prevFtpCode !== ftpCode)
            this.init()
    }


    submit = async () => {

        const message = this.state.form.values.message

        if (!message) {
            console.log("invalido")
            return null
        }

        const topic = await EadRequests.getForumTopic(this.state.ftpCode)

        const {person} = this.state

        const forumPostDTO = {
            forumTopicDTO: topic,
            personPostCode: person.code,
            personPostName: person.name,
            personTypesPost: person.types,
            postDate: moment(),
            post: message
        }

        const result = await EadRequests.saveForumPost(forumPostDTO)


        const success = result.success

        if (success) {

            const elemDOM = document.querySelector('.master')
            elemDOM.scrollTop = 0;

            this.props.context.set({
                toastMessage: {
                    type: 'success',
                    content: 'Postagem realizada com sucesso!'
                }
            })

            this.setState({
                messageSent: message
            })
        } else {
            this.props.error({
                title: "Erro ao enviar mensagem!",
                message: "Ocorreu um erro ao enviar a mensagem. Recarregue a página e tente novamente. Caso o erro persista, entre em contato conosco.",
                position: 'tr',
                autoDismiss: 6
            })
        }
    }


    onFormMessageChange = (form) => {
        this.setState({form})
    }


    render() {
        const {
            awaiting,
            initialized,
            messageSent,
            description

        } = this.state

        return (
            <div className={'mc-ead-content-forum-post'}>
                <div className="content">
                    <MCEadContentCard>

                        <MCLoadingOverlay show={awaiting}/>
                        {
                            initialized ? (
                                    <React.Fragment>
                                        <MCEadTitle style={{marginBottom: '0.8rem'}} title={'Instruções:'} small/>
                                        {
                                            description &&
                                            <div
                                                style={{padding: '1rem', border: '1px solid #dedede', marginBottom: '1rem'}}
                                                dangerouslySetInnerHTML={{__html: description}}
                                            />
                                        }
                                        <div style={{width: "100%"}}>
                                            <NRTFormStateManager ref={f => this.form = f}
                                                                 onStateChange={this.onFormMessageChange} debug>
                                                <NRTVerticalStack>
                                                    <NRTFormInput
                                                        ref={(input) => this.textMessage = input}
                                                        value={messageSent}
                                                        disabled={messageSent}
                                                        type={'textarea'}
                                                        name={'message'}
                                                        validators={[
                                                            Validators.required()
                                                        ]}
                                                        customProps={{rows: '15'}}
                                                    />

                                                    <ButtonWithChevron buttonLabel={'Enviar'}
                                                                       secondary
                                                                       onClick={this.submit}
                                                                       disabled={this.state.form.valid === false || messageSent}
                                                                       style={{margin: "0 auto"}}
                                                    />
                                                </NRTVerticalStack>
                                            </NRTFormStateManager>
                                        </div>
                                    </React.Fragment>
                                )
                                : null

                        }
                    </MCEadContentCard>
                </div>
            </div>
        )
    }
}


MCEadContentForumPost.propTypes = {
    message: PropTypes.string,
    //htmlContent: PropTypes.string.isRequired,
    context: PropTypes.object.isRequired,
    onError: PropTypes.func.isRequired,
}

MCEadContentForumPost.defaultProps = {}


export default MCEadContentForumPost



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/ForumPost/index.js